import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import {
  CreateEPrijemnicaCommand, EOtpremniceClient,
  ICreateEPrijemnicaCommand,
  IOdobriOdbaciSefRacunCommand, OdobriOdbaciSefRacunCommand,
  StavkaOtpremniceDto, TipRacuna
} from '@kodit/core/data-api';
import { Observable, Subscription } from 'rxjs';
import { KreiranjePrijemniceFormService } from '../kreiranje-prijemnice-form.service';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { AlertService, ensureFileUrl } from '@kodit/core/services';
import { StavkaEoptremniceFormService } from '../../form-definitions/stavka-eotpremnice-form.service';
import { finalize, map } from 'rxjs/operators';
import { FormHelper } from '@kodit/core/form-definitions';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'kodit-kreiranje-prijemnice-form',
  templateUrl: './kreiranje-prijemnice-form.component.html',
  styleUrls: ['./kreiranje-prijemnice-form.component.scss']
})
export class KreiranjePrijemniceFormComponent implements OnInit, OnDestroy{

  /** Form */
  form: FormGroupTypeSafe<ICreateEPrijemnicaCommand>;
  stavkePrijemnice: StavkaOtpremniceDto[];
  pdfFileUrl: string;
  tipRacuna: TipRacuna = TipRacuna.EPRIJEMNICA;

  /** Subscription */
  private _subs: Subscription = new Subscription();

  constructor(
    private _fs: KreiranjePrijemniceFormService,
    public _dialogConfig: DynamicDialogConfig,
    public _client: EOtpremniceClient,
    public _dialogRef: DynamicDialogRef,
    private _alertService: AlertService,
    private _stavkeService: StavkaEoptremniceFormService,
    private _formHelper: FormHelper,
  ) { }

  ngOnInit(): void {
    //this.stavkePrijemnice = this._getStavkeOtpremnice(this._dialogConfig.data?.id);
    this._subs.add(
      this._getStavkeOtpremnice(this._dialogConfig.data?.id)
        .subscribe(stavke => {
          this.form = this._fs.GetFormGroup(stavke);
          this.form.controls.eOtpremniceId?.patchValue(this._dialogConfig.data?.id);
          this._fs.setForm = this.form;
        })
    );
    this._getPdfOtpremnice();

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._save();
      })
    );
  }

  private _getStavkeOtpremnice(id: number): Observable<StavkaOtpremniceDto[]> {
    return this._client.getStavkeOtpremnice(id).pipe(
      map(res => res.data as StavkaOtpremniceDto[])
    );
  }

  private _save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }
    const cleanedValue = this._cleanForBackend(this.form?.value);
    this._subs.add(
      this._client
        .createPrijemnica(cleanedValue as CreateEPrijemnicaCommand)
        .subscribe((res) => {
          if (!res.succeeded) {
            this._alertService.addWarnMsgs(res.messages);
          } else {
            this._alertService.addSuccessMsg("Uspesno kreirana prijemnica");
          }
          this._dialogRef.close(true);
        })
    );
  }

  private _cleanForBackend(value: any): any {
    const cleaned = JSON.parse(JSON.stringify(value));
    if (Array.isArray(cleaned.stavkeDto)) {
      cleaned.stavkeDto = cleaned.stavkeDto.map((stavka: any) => {
        if (
          stavka.akciznaKategorijaDto &&
          Object.values(stavka.akciznaKategorijaDto).every(
            (v) => v === null || v === ''
          )
        ) {
          stavka.akciznaKategorijaDto = null;
        }
        return stavka;
      });
    }

    return cleaned;
  }

  prihvatiUCelosti(): void {
    const stavke = this.form.get('stavkeDto') as FormArray;

    stavke.controls.forEach((stavka: FormGroup) => {
      const kolicina = stavka.get('kolicina')?.value ?? 0;

      stavka.patchValue({
        pristiglaKolicina: kolicina,
        primljenaKolicina: kolicina,
        vracenaKolicina: 0
      });
    });
  }

  odbijUCelosti(): void {
    const stavke = this.form.get('stavkeDto') as FormArray;

    stavke.controls.forEach((stavka: FormGroup) => {
      const kolicina = stavka.get('kolicina')?.value ?? 0;

      stavka.patchValue({
        pristiglaKolicina: kolicina,
        primljenaKolicina: 0,
        vracenaKolicina: kolicina
      });
    });
  }

  private _getPdfOtpremnice() {
    this._subs.add(
      this._client
        .getDokumentUrl(this._dialogConfig.data?.id)
        .subscribe((res) => {
          this.pdfFileUrl = ensureFileUrl(res.data);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
